import React from 'react'
import FilestackUploader from '../common/filestack_uploader/main'

export default class LogoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filestackUpload: null
    };
  };

  updateLogoFormState(key, value) {
    this.setState({ [key]: value });
    if(key === 'filestackUpload') { this.getLogoMetadata(value)};
  }

  submitLogo(e) {
    e.preventDefault();
    this.props.updateOnboarding({logo: this.state.filestackUpload, stage: this.props.stage + 1 });
  }

  getLogoMetadata(filestackUpload) {
    let logoUrl = this.state.filestackUpload.url;
    let url     = `/api/v3/color_extraction?url=${logoUrl}`;
    let that    = this;
    let xhr     = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader("X-CSRF-TOKEN", this.props.authenticityToken);
    xhr.setRequestHeader("Content-type", 'application/json');
    xhr.onreadystatechange = function () {
      if(this.readyState == 4 && this.status == 200) {
        that.props.updateOnboarding({colors: JSON.parse(this.response)});
      } else if (this.readyState == 4) {
        console.log('color extraction failed');
      }
    }
    xhr.send();
  }

  skipLogoUpload() {
    this.props.updateOnboarding({stage: this.props.stage + 1});
  }

  showBanner() {
    if(this.state.filestackUpload) {
      return (<h2 className='content--step0__feedback'>Success!</h2>)
    }
  }

  showUploadedFileName() {
    let {filestackUpload} = this.state;
    if(filestackUpload) {
      return (
        <div className='content--step0__filename'>
          <h4>{(filestackUpload.filename.length >= 25) ? `${filestackUpload.filename.substring(0, 25)}...` : filestackUpload.filename}</h4>
          <div className='content--step0__file-options'>
            <h4 className='content--step0__file-remove link' onClick={ () => {
              this.props.updateOnboarding({logo: null});
              this.setState({filestackUpload: null});
            }}>Delete</h4>
            <h4> | </h4>
          </div>
        </div>
      )
    };
  }

  showUploadedFile() {
    if(this.state.filestackUpload) {
      return ( <img src={this.state.filestackUpload.url} className='content--step0__img' /> )
    };
  }

  addFiles(files) {
    let file = files.filesUploaded[0];
    this.updateLogoFormState('filestackUpload', file);
    this.props.updateOnboarding({'logo': file})
  }

  onError(file, error) {
    console.log(error);
  }

  showFileStack() {
    if(!this.state.filestackUpload) {
      return (
        <div className="guest-upload-box">
          <h3>Upload Your Company's Logo</h3>
          <FilestackUploader
            type="area"
            options={{ maxFiles: 1 }}
            onSuccess={this.addFiles.bind(this)}
            onError={this.onError.bind(this)} />
        </div>
      )
    } else {
      return (
        <FilestackUploader
          type="link"
          text="Update"
          options={{ maxFiles: 1 }}
          onSuccess={this.addFiles.bind(this)}
          onError={this.onError.bind(this)} />
      )
    }
  }

  showSkipForNow() {
    if(!this.state.filestackUpload) {
      return <h4 className='content--step0--skip content__bot-div link' onClick={(e) => this.skipLogoUpload(e)}>Skip for now</h4>
    }
  }

  render() {
    return (
      <div className='content content--step0'>
        {this.showBanner()}
        <form>
          {this.showUploadedFile()}
          <div className='content--step0__file-info'>
            {this.showUploadedFileName()}
            {this.showFileStack()}
          </div>
        </form>
        <button className='dark content--step0__btn'
                onClick={(e) => this.submitLogo(e)}
                disabled={!this.state.filestackUpload}>
          Next Step
        </button>
        {this.showSkipForNow()}
      </div>
    )
  }
}
